export enum EFormSectionStatus {
  FILLED = 'Filled',
  TO_BE_FILLED = 'ToBeFilled',
  FILLING = 'Filling',
}

export interface IFormSectionProps {
  title: string;
  children: React.ReactNode;
  status?: EFormSectionStatus;
  collapsible?: boolean;
  hidden?: boolean;
}
